import Vue from 'vue'
import App from './App.vue'
import router from './router/index'

// ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import moment from 'moment'
Vue.prototype.$moment = moment

// flexible
import 'lib-flexible';

// 实现element-ui中dialog的拖拽
import './utils/dialog'

// 解析数学表达式
import mathJax from "./utils/mathJax"; // 引入样式
Vue.prototype.mathJax = mathJax;

// 全局组件
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Admin_Header from './components/Admin_Header.vue';
import Admin_Side from './components/Admin_Side.vue';
// 弹出层
import NewDialog from '@/components/NewDialog'
// 抽屉
import NewDrawer from '@/components/NewDrawer'
// 分页组件
import Pagination from "@/components/Pagination";

// 全局组件挂载
Vue.component('Header', Header)
Vue.component('Footer', Footer)
Vue.component('Admin_Header', Admin_Header)
Vue.component('Admin_Side', Admin_Side)
Vue.component('Pagination', Pagination)
Vue.component('NewDialog', NewDialog)
Vue.component('NewDrawer',NewDrawer)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
